// Gospa De Fe — soft reveal animations (pairs with gospa-animations.css).
(function () {
  var root = document.documentElement;
  if (!root.classList.contains('gf-anim')) return;

  // Things that fade in, in order, inside each section.
  var SINGLE = [
    '.banner__heading',
    '.banner__text',
    '.banner__buttons',
    '.title-wrapper-with-link',
    '.title-wrapper',
    '.collection__title',
    '.multicolumn .title',
    '.rich-text__blocks > *',
    '.footer__content-top',
    '.footer__content-bottom',
    '.product__info-wrapper',
    '.product__media-wrapper',
    '.main-page-title',
    '.rte',
  ];
  // Grids whose items cascade one after another.
  var GRID_ITEM = '.grid > .grid__item, .slider > .grid__item';
  var STEP = 140; // ms between items
  var MAX_STEPS = 6;

  function mark(el, delay) {
    if (el.classList.contains('gf-reveal')) return;
    // Header and announcement bar animate as a whole (see CSS), not piece by piece.
    if (el.closest('.announcement-bar-section, .section-header, cart-drawer')) return;
    el.classList.add('gf-reveal');
    el.style.setProperty('--gf-delay', delay + 'ms');
  }

  function prepare(scope) {
    // Hero texts get a fixed stagger after the banner image appears.
    scope.querySelectorAll('.banner__box').forEach(function (box) {
      ['.banner__heading', '.banner__text', '.banner__buttons'].forEach(function (sel, i) {
        box.querySelectorAll(sel).forEach(function (el) {
          mark(el, 350 + i * 220);
        });
      });
    });

    scope.querySelectorAll(SINGLE.join(',')).forEach(function (el) {
      mark(el, 0);
    });

    var seen = new Set();
    scope.querySelectorAll(GRID_ITEM).forEach(function (item) {
      var grid = item.parentElement;
      // Rotating sliders (announcement bar, slideshows) move items sideways; leave them alone.
      if (grid.closest('.announcement-bar-section, slideshow-component')) return;
      if (seen.has(grid)) return;
      seen.add(grid);
      Array.prototype.forEach.call(grid.children, function (child, i) {
        if (child.classList.contains('grid__item')) mark(child, Math.min(i, MAX_STEPS) * STEP);
      });
    });
  }

  function reveal(el) {
    el.classList.add('gf-armed', 'gf-in');
  }

  function observe(scope) {
    var items = scope.querySelectorAll('.gf-reveal:not(.gf-in)');
    if (!('IntersectionObserver' in window)) {
      items.forEach(reveal);
      return;
    }
    var io = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            reveal(entry.target);
            io.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }
    );
    items.forEach(function (el) {
      io.observe(el);
    });
  }

  function start() {
    prepare(document);
    // Let the hidden state paint once so the first transition actually plays.
    // setTimeout instead of requestAnimationFrame: rAF stalls in background tabs.
    setTimeout(function () {
      document.querySelectorAll('.gf-reveal').forEach(function (el) {
        el.classList.add('gf-armed');
      });
      void root.offsetHeight; // commit the hidden state before revealing
      root.classList.add('gf-loaded');
      revealVisible(); // above-the-fold content starts right away
      observe(document);
    }, 60);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  // Safety net: never leave on-screen content hidden, even if the observer never fires.
  function revealVisible() {
    document.querySelectorAll('.gf-reveal:not(.gf-in)').forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.top < window.innerHeight * 0.92 && r.bottom > 0) reveal(el);
    });
  }

  setTimeout(function () {
    root.classList.add('gf-loaded');
    revealVisible();
  }, 2500);

  var scrollTimer = null;
  window.addEventListener(
    'scroll',
    function () {
      if (scrollTimer) return;
      scrollTimer = setTimeout(function () {
        scrollTimer = null;
        revealVisible();
      }, 150);
    },
    { passive: true }
  );

  // Theme editor: show everything immediately when sections reload.
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', function (e) {
      prepare(e.target);
      e.target.querySelectorAll('.gf-reveal').forEach(reveal);
    });
  }
})();
